import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgressBarService {

  private dataSubject: Subject<boolean> = new Subject<boolean>()

  constructor() { }

  sendData(data: boolean) {
    this.dataSubject.next(data);
  }

  getData() {
    this.dataSubject.observers = [];
    return this.dataSubject.asObservable();
  }
  
}
